// @flow

export const getDisabledNode = (checkedIdsList: Array<string>, notEmpty: ?boolean): null | string => {
    let disabledNode = null;
    if (notEmpty && checkedIdsList.length === 1) {
        disabledNode = checkedIdsList[0];
    }
    return disabledNode;
};
